import { type IconProps } from '@carvana/ds-icons';
import { icon } from '@carvana/ds-styles';
import Clickable from '@carvana/merch-components/Clickable';
import TrackClick from '@carvana/merch-components/TrackClick';
import { ChevronRight } from 'lucide-react';
import React from 'react';

export type OwnProps = {
  action: string | ((ev: React.MouseEvent<HTMLElement>) => void);
  className?: string;
  icon: (_: IconProps) => React.ReactElement;
  nativePayload: Record<string, any>;
  text: string;
  testId?: string;
};

function TileContents(props: OwnProps) {
  return (
    <div className="grid grid-cols-[auto_1fr_auto] items-center gap-lg">
      <props.icon color={icon.inverse} strokeWidth={1} size={32} />
      <p>{props.text}</p>
      <ChevronRight color={icon.inverse} size={24} />
    </div>
  );
}

export default function Tile(props: OwnProps) {
  const { action } = props;

  return typeof action === 'string' ? (
    <TrackClick<HTMLAnchorElement>
      element="a"
      href={action}
      className={props.className}
      data-analytics-id="Hero CTA"
      data-testid={props.testId}
      data-analytics-attributes={{ text: props.text }}
      data-native-payload={props.nativePayload}
    >
      <TileContents {...props} />
    </TrackClick>
  ) : (
    <Clickable
      onClick={action}
      className={props.className}
      data-analytics-id="Hero CTA"
      data-testid={props.testId}
      data-analytics-attributes={{ text: props.text }}
    >
      <TileContents {...props} />
    </Clickable>
  );
}
